export default __webpack_public_path__ + "static/media/br_ad_banner_mobile.ec46cc12.jpg";